import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

const get = (url, params) => axios.get(url, { params, withCredentials: true }).then((r) => r.data);

// Loads each source independently; compare mode fetches previous + current range in parallel
export function useRangeSources(sources, range, mode) {
  const [state, setState] = useState({});
  const reqId = useRef(0);
  const compare = mode === 'compare';
  const key = sources.map((s) => s.key).join(',');

  const load = useCallback((refresh = false) => {
    const id = ++reqId.current;
    const ranges = compare ? [[range.prevFrom, range.prevTo], [range.from, range.to]] : [[range.from, range.to]];
    sources.forEach((s) => {
      setState((p) => ({ ...p, [s.key]: { items: p[s.key]?.items || [], loading: true, error: null, fetchedAt: p[s.key]?.fetchedAt } }));
      const extra = refresh ? { refresh: true } : {};
      const calls = s.noRange
        ? [get(s.url, extra)]
        : ranges.map(([f, t]) => get(s.url, { date_from: f, date_to: t, ...extra }));
      Promise.all(calls)
        .then((rs) => id === reqId.current && setState((p) => ({
          ...p, [s.key]: { items: rs.flatMap((r) => r.items), loading: false, error: null, fetchedAt: rs[rs.length - 1].fetched_at },
        })))
        .catch((e) => id === reqId.current && setState((p) => ({
          ...p, [s.key]: { ...p[s.key], loading: false, error: e.response?.data?.detail || 'Nepodařilo se načíst data z K2' },
        })));
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, compare, range.from, range.to, range.prevFrom, range.prevTo]);

  useEffect(() => { load(); }, [load]);
  const src = (k) => state[k] || { items: [], loading: true, error: null };
  return { src, reload: () => load(true), anyLoading: sources.some((s) => src(s.key).loading) };
}
